module.exports = {"markup":"<span class=\"inline-thumb inline-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"> <path fill=\"#FFF\" d=\"M33.78 22.437l-4.228 13.98L27.93 37.5 5.062 34.14V15.503l7.8-1.517L24.354 2.5h1.624L28.9 5.426l-4.548 8.67h.107l10.477 1.31\"></path> </svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/thumb.svg
// module id = 193
// module chunks = 0 15